import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatSliderModule} from '@angular/material/slider';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {SharedModule} from '@app/shared';
import {CartState} from '@app/store/state/cart.state';
import {AlertModule, LoaderModule} from '@infomaniak/angular-common';
import {TranslocoModule} from '@ngneat/transloco';
import {NgxsModule} from '@ngxs/store';
import {SwiperModule} from 'ngx-swiper-wrapper';

import {DriveComponent} from './drive.component';
import {DriveService} from './drive.service';
import {TooltipModule} from '@infomaniak/ngx-tooltip-directive';

export const routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DriveComponent
  }
];

@NgModule({
  declarations: [DriveComponent],
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    CommonModule,
    SharedModule,
    NgxsModule.forFeature([CartState]),
    TranslocoModule,
    MatButtonModule,
    MatTooltipModule,
    MatChipsModule,
    MatDialogModule,
    MatInputModule,
    SwiperModule,
    AlertModule,
    LoaderModule,
    MatSliderModule,
    TooltipModule
  ],
  exports: [DriveComponent],
  providers: [DriveService]
})
export class DriveModule {
}
